import {CalendarFormat} from './calendar-format.enum';
import {NonWorkingDay} from './non-working-day';
import {StartOfDay} from './start-of-day.enum';
import {StartOfWeek} from './start-of-week.enum';

export class ScheduleCustomSettings {
  private _calendarFormat: CalendarFormat;
  private _startOfWeek: StartOfWeek;
  private _startOfDay: StartOfDay;
  private _nonWorkingDays: NonWorkingDay[];

  public constructor(calendarFormat: CalendarFormat, startOfWeek: StartOfWeek, startOfDay: StartOfDay, nonWorkingDays: NonWorkingDay[]) {
    this._calendarFormat = calendarFormat;
    this._startOfWeek = startOfWeek;
    this._startOfDay = startOfDay;
    this._nonWorkingDays = nonWorkingDays;
  }

  public get calendarFormat(): CalendarFormat {
    return this._calendarFormat;
  }

  public set calendarFormat(value: CalendarFormat) {
    this._calendarFormat = value;
  }

  public get startOfWeek(): StartOfWeek {
    return this._startOfWeek;
  }

  public set startOfWeek(value: StartOfWeek) {
    this._startOfWeek = value;
  }

  public get startOfDay(): StartOfDay {
    return this._startOfDay;
  }

  public set startOfDay(value: StartOfDay) {
    this._startOfDay = value;
  }

  public get nonWorkingDays(): NonWorkingDay[] {
    return this._nonWorkingDays;
  }

  public set nonWorkingDays(value: NonWorkingDay[]) {
    this._nonWorkingDays = value;
  }

  public static fromJSON(scheduleCustomSettingsJSON: any): ScheduleCustomSettings {
    return new ScheduleCustomSettings(
      scheduleCustomSettingsJSON.calendarFormat,
      scheduleCustomSettingsJSON.dayOfWeek,
      scheduleCustomSettingsJSON.dayStart,
      scheduleCustomSettingsJSON.nonWorkingDays?.map((nonWorkingDay: any) => NonWorkingDay.fromJSON(nonWorkingDay)) ?? []
    );
  }

  public toJSON(): JSON {
    return {
      calendarFormat: this._calendarFormat,
      dayOfWeek: this._startOfWeek,
      dayStart: this._startOfDay,
      nonWorkingDays: this._nonWorkingDays?.map((nonWorkingDay: NonWorkingDay) => nonWorkingDay.toJSON()) ?? []
    } as any as JSON;
  }
}
